import { render } from "./vacancySlider2.vue?vue&type=template&id=3b272491&scoped=true"
import script from "./vacancySlider2.vue?vue&type=script&lang=js"
export * from "./vacancySlider2.vue?vue&type=script&lang=js"

import "./vacancySlider2.vue?vue&type=style&index=0&id=3b272491&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b272491"]])

export default __exports__